<template>
  <div>
    <header-component />

    <section class="w-100 d-inline-block join-wrap">
      <div class="join-bg join-bg--left" aria-hidden="true"></div>
      <div class="join-bg join-bg--right" aria-hidden="true"></div>

      <div class="container autoContent">
        <div class="row justify-content-center">
          <div class="col-xl-5 col-lg-6 col-md-8 col-11">
            <div class="text-center mb-2">
              <div class="join-page-title filson-black-family text-uppercase text-black">
                Login your Account
              </div>
            </div>

            <div class="w-100 d-inline-block join-card bg-white rounded-3 shadow-sm">
              <div class="text-center">
                <div class="join-subtitle inter-bold-family text-uppercase text-black">
                  Login to your dashboard
                </div>
              </div>

              <div v-if="error" class="alert alert-danger mt-3 mb-0" role="alert">
                {{ error }}
              </div>

              <form class="w-100 d-inline-block mt-3" @submit.prevent="submit">
                <div class="w-100 d-inline-block mb-2">
                  <label class="join-label inter-regular-family text-black text-full-11">
                    Email<span class="join-req" aria-hidden="true">*</span>
                  </label>
                  <input
                    v-model.trim="form.email"
                    class="join-input"
                    type="email"
                    placeholder="email@address.com"
                    required
                  >
                </div>

                <div class="w-100 d-inline-block mb-2">
                  <label class="join-label inter-regular-family text-black text-full-11">
                    Password<span class="join-req" aria-hidden="true">*</span>
                  </label>
                  <input
                    v-model="form.password"
                    class="join-input"
                    type="password"
                    placeholder="Enter password"
                    required
                    minlength="6"
                  >
                </div>

                <button type="submit" class="join-cta join-cta--centered" :disabled="submitting || !canSubmit">
                  <span class="inter-bold-family text-uppercase text-full-11">
                    {{ submitting ? 'LOGGING IN...' : 'LOGIN' }}
                  </span>
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>

    <footer-component />
  </div>
</template>

<script>
import headerComponent from '../header/headerComponent.vue';
import footerComponent from '../footer/footerComponent.vue';

export default {
  name: 'PartnerLoginPage',
  components: { headerComponent, footerComponent },
  data() {
    return {
      submitting: false,
      error: '',
      form: {
        email: '',
        password: '',
      },
    };
  },
  computed: {
    canSubmit() {
      return Boolean(this.form.email && this.form.password);
    },
  },
  methods: {
    async submit() {
      this.error = '';
      this.submitting = true;
      try {
        const res = await this.$axios.post('/partner/login', {
          email: this.form.email,
          password: this.form.password,
        });
        if (res?.data?.success) {
          const joinType = String(res.data.joinType || 'user').toLowerCase();
          try {
            localStorage.setItem('partner_auth', JSON.stringify({
              joinType,
              email: this.form.email,
              token: String(res.data.token || ''),
            }));
          } catch (_) {
            // ignore
          }
          const dest = joinType === 'user' ? '/dashboard/user' : `/dashboard/${joinType}`;
          this.$router.push({ path: dest });
        } else {
          this.error = res?.data?.message || 'Could not log in. Please try again.';
        }
      } catch (e) {
        this.error = e?.response?.data?.message || 'Could not log in. Please try again.';
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>

<style scoped>
.join-wrap {
  position: relative;
  background: #f5f6f7;
  padding: 56px 0;
  overflow: hidden;
}

.join-bg {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 220px;
  pointer-events: none;
  opacity: 0.18;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.join-bg--left {
  left: -40px;
  background-image: url("~@/assets/images/join-page-cat.png");
}

.join-bg--right {
  right: -40px;
  background-image: url("~@/assets/images/join-page-dog.png");
}

.join-page-title {
  font-size: 26px;
  letter-spacing: 0.08em;
}

.join-card {
  padding: 18px 18px 16px;
  border: 1px solid rgba(0, 0, 0, 0.06);
}

.join-subtitle {
  font-size: 13px;
  letter-spacing: 0.08em;
}

.join-label {
  display: inline-block;
  margin-bottom: 6px;
}

.join-req {
  color: #f8721f;
  margin-left: 4px;
  font-weight: 700;
}

.join-input {
  width: 100%;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 10px;
  padding: 12px 12px;
  outline: none;
  background: #fff;
}

.join-input:focus {
  border-color: #f8721f;
  box-shadow: 0 0 0 3px rgba(248, 114, 31, 0.18);
}

.join-cta {
  width: 100%;
  border: 0;
  border-radius: 10px;
  padding: 12px 16px;
  background: #f8721f;
  color: #fff;
  margin-top: 10px;
}

.join-cta[disabled] {
  opacity: 0.6;
  cursor: not-allowed;
}

@media (max-width: 575px) {
  .join-wrap {
    padding: 38px 0;
  }
  .join-bg {
    display: none;
  }
}
</style>

